module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step1-3-bba6772096058618caa677f07df36577.gif";